// export const BASE_API_URL = "https://dev.api.vlc-control.idc.md";
export const BASE_API_URL = "https://api.vlc-control.idc.md";

// номер версии с датой
export const version = "4.4.4 от 03.07.2026";
